export default function separateNumberFormat(num: number) {
  if(Number.isInteger(num)){
    return parseFloat(num.toFixed(2))?.toLocaleString("id-Id");
  }else{
    return num?.toLocaleString("id-Id");
  }
}
